import React from 'react';

function Sparkline({ data = [], title, unit }) {
  const points = data.slice(-30);
  const max = Math.max(...points.map((p) => p.v || 0), 1);
  return (
    <div className="card shadow-sm mb-3">
      <div className="card-body py-2">
        <div className="d-flex justify-content-between align-items-center mb-1">
          <div className="text-muted small text-uppercase">{title}</div>
          <div className="small text-muted">
            {points.length ? `${points[points.length - 1].v} ${unit || ''}` : '—'}
          </div>
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${points.length || 1}, 1fr)`,
            gap: '2px',
            alignItems: 'end',
            minHeight: '50px',
          }}
        >
          {points.map((p, idx) => (
            <div
              key={p.t || idx}
              title={`${p.v} ${unit || ''}`}
              style={{
                height: `${(Math.max(p.v, 0) / max) * 100 || 0}%`,
                background: 'linear-gradient(135deg,#6dd5fa,#2980b9)',
                borderRadius: '2px',
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default function MetricsCharts({
  latencySeries = [],
  sweepSeries = [],
  diffSeries = [],
}) {
  if (!latencySeries.length && !sweepSeries.length && !diffSeries.length) {
    return null;
  }
  return (
    <div className="row g-2 g-md-3">
      <div className="col-12 col-md-4">
        <Sparkline data={latencySeries} title="Latency" unit="ms" />
      </div>
      <div className="col-12 col-md-4">
        <Sparkline data={sweepSeries} title="Sweep time" unit="ms" />
      </div>
      <div className="col-12 col-md-4">
        <Sparkline data={diffSeries} title="Diff updates" unit="" />
      </div>
    </div>
  );
}
